module.exports = {"653101001":"恰萨街道","653101002":"亚瓦格街道","653101003":"吾斯塘博依街道","653101004":"库木代尔瓦扎街道","653101005":"西域大道街道","653101006":"东湖街道","653101007":"迎宾大道街道","653101008":"西公园街道","653101100":"乃则尔巴格镇","653101101":"夏马勒巴格镇","653101202":"多来特巴格乡","653101203":"浩罕乡","653101204":"色满乡","653101205":"荒地乡","653101206":"帕哈太克里乡","653101207":"伯什克然木乡","653101208":"阿瓦提乡","653101209":"英吾斯坦乡","653101210":"阿克喀什乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653101.json
// module id = 3247
// module chunks = 0